import { Injectable, OnDestroy } from '@angular/core';

import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { Observable, Subject, takeUntil } from 'rxjs';

import { EventDetailsComponent } from '../event-details.component';

@Injectable({ providedIn: 'root' })
export class LiveEventsNavigationRouteService implements OnDestroy {
    private stopStream$: Subject<void> = new Subject<void>();
    protected serviceDestroyed$ = new Subject<void>();

    constructor(private routerEvents: RouterEventsService) {
        this.routerEvents.currentActivationStart.pipe(takeUntil(this.serviceDestroyed$)).subscribe((route) => {
            if (route && route.snapshot.component !== EventDetailsComponent) {
                this.stopStream$.next();
                this.stopStream$.complete();
            }
        });
    }

    ngOnDestroy(): void {
        this.serviceDestroyed$.next();
        this.serviceDestroyed$.complete();
    }

    get stopProcessing$(): Observable<void> {
        return this.stopStream$.asObservable();
    }
}
